var _excluded = ["columns", "normalizedItems", "onScroll", "onViewportChange", "renderCell", "getTextValue", "aria-label", "density", "selectedKeys", "defaultSelectedKeys", "disabledKeys", "onSelectionChange"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import { useCallback } from 'react';
import { Cell, Column, Row, TableBody, TableHeader } from '@adobe/react-spectrum';
import { TABLE_VIEW_ROW_HEIGHTS } from "../../UIConstants.js";
import { useSpectrumThemeProvider } from "../../theme/index.js";
import { TableViewWrapper } from "./TableViewWrapper.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** Renders normalized, keyed row data in a resizable Spectrum TableView. */
export function TableViewNormalized(_ref) {
  var columns = _ref.columns,
    normalizedItems = _ref.normalizedItems,
    onScroll = _ref.onScroll,
    onViewportChange = _ref.onViewportChange,
    renderCell = _ref.renderCell,
    getTextValue = _ref.getTextValue,
    _ref$ariaLabel = _ref['aria-label'],
    ariaLabel = _ref$ariaLabel === void 0 ? 'Table' : _ref$ariaLabel,
    _ref$density = _ref.density,
    density = _ref$density === void 0 ? 'compact' : _ref$density,
    selectedKeys = _ref.selectedKeys,
    defaultSelectedKeys = _ref.defaultSelectedKeys,
    disabledKeys = _ref.disabledKeys,
    onSelectionChange = _ref.onSelectionChange,
    spectrumProps = _objectWithoutProperties(_ref, _excluded);
  var _useSpectrumThemeProv = useSpectrumThemeProvider(),
    scale = _useSpectrumThemeProv.scale;

  // Row keys are numeric indices; Spectrum stringifies JSX keys, so we must
  // convert selection props to strings and convert results back to numbers.
  var toStringSet = keys => {
    if (keys == null) return undefined;
    if (keys === 'all') return 'all';
    return new Set([...keys].map(String));
  };
  var handleSelectionChange = useCallback(keys => {
    if (onSelectionChange == null) return;
    if (keys === 'all') {
      onSelectionChange('all');
      return;
    }
    // Recover numeric type where possible; keep strings for non-numeric keys
    onSelectionChange(new Set([...keys].map(k => {
      var n = Number(k);
      return Number.isNaN(n) ? k : n;
    })));
  }, [onSelectionChange]);
  return /*#__PURE__*/_jsxs(TableViewWrapper, _objectSpread(_objectSpread({
    "aria-label": ariaLabel,
    density: density,
    selectionMode: "none",
    selectedKeys: toStringSet(selectedKeys),
    defaultSelectedKeys: toStringSet(defaultSelectedKeys),
    disabledKeys: toStringSet(disabledKeys),
    onSelectionChange: onSelectionChange != null ? handleSelectionChange : undefined,
    onScroll: onScroll,
    itemCount: normalizedItems.length,
    rowHeight: TABLE_VIEW_ROW_HEIGHTS[density !== null && density !== void 0 ? density : 'compact'][scale],
    onViewportChange: onViewportChange
    // eslint-disable-next-line react/jsx-props-no-spreading
  }, spectrumProps), {}, {
    children: [/*#__PURE__*/_jsx(TableHeader, {
      columns: columns,
      children: column => /*#__PURE__*/_jsx(Column, {
        width: column.width,
        defaultWidth: column.defaultWidth,
        minWidth: column.minWidth,
        maxWidth: column.maxWidth,
        align: column.align,
        allowsResizing: column.allowsResizing,
        allowsSorting: column.allowsSorting,
        showDivider: column.showDivider,
        hideHeader: column.hideHeader,
        children: column.name
      }, column.key)
    }), /*#__PURE__*/_jsx(TableBody, {
      items: normalizedItems,
      children: _ref2 => {
        var _getTextValue;
        var key = _ref2.key,
          item = _ref2.item;
        return /*#__PURE__*/_jsx(Row, {
          textValue: item == null ? '' : (_getTextValue = getTextValue === null || getTextValue === void 0 ? void 0 : getTextValue(item)) !== null && _getTextValue !== void 0 ? _getTextValue : '',
          children: columnKey => /*#__PURE__*/_jsx(Cell, {
            children: item == null ? null : renderCell(item, columnKey)
          })
        }, key);
      }
    })]
  }));
}
export default TableViewNormalized;
//# sourceMappingURL=TableViewNormalized.js.map